export enum ChampionshipTeamUploadState {
    Missing = "Missing",
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected"
}
